export default __webpack_public_path__ + "static/media/B5EB81DB-E6FC-461F-A416-A89183B07D58_1_105_c.27b5cf07.jpeg";